import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'phone'})
export class PhonePipe implements PipeTransform {
    
  transform(phoneNumber: string): string {
    const formatedNumber: string = phoneNumber ? phoneNumber.replace(/(.{3})/g, "$1 ") : '';
    return formatedNumber;
  }
}